<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="170px">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入活动名称" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="开启口令增加抽奖次数 ">
        <el-radio-group v-model="form.cipherStatus" @change="selectCipherStatus">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="口令id" prop="cipherId">
        <el-input v-model="form.cipherId" placeholder="请输入口令id" :clearable="true"
          :disabled="form.cipherStatus == 1 ? false : true"></el-input>
      </el-form-item>
      <el-form-item label="限制参与人数" prop="userLimit">
        <el-input v-model.number="form.userLimit" placeholder="请输入限制参与人数" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="总限制次数" prop="countLimit">
        <el-input v-model.number="form.countLimit" placeholder="请输入总限制次数" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="每日限制抽奖次数" prop="dayCountLimit">
        <el-input v-model.number="form.dayCountLimit" placeholder="请输入每日限制抽奖次数" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="默认抽奖次数" prop="defaultCount">
        <el-input v-model.number="form.defaultCount" placeholder="请输入默认抽奖次数" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="选项">
        <el-tabs v-model="optionValue" type="border-card" @tab-remove="removeTab">
          <el-tab-pane label="奖品集合" :name="0">
            <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
              <div style="text-align: center;color: #66b1ff;width: 99%;margin: 0px auto;margin-bottom: 24px; ">奖品区域
              </div>
              <el-collapse accordion>
                <el-collapse-item v-for="(item, index) in form.gifts" :key="index">
                  <span slot="title" style="font-size:15px;font-weight:600; margin:20px;">奖品名称： {{ item.name }}</span>
                  <el-form-item label="奖品名称" size="mini" required>
                    <el-input v-model="item.name" placeholder="请输入奖品名称" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="数量" required>
                    <el-input v-model="item.count" size="mini" placeholder="请输入奖品数量" :clearable="true"></el-input>
                  </el-form-item>
                  <el-collapse accordion>
                    <el-collapse-item>
                      <span style="font-size:14px;font-weight:600; margin:20px;padding-left:110px" slot="title">
                        奖品信息
                        <i class="header-icon el-icon-info" style="margin-left: 10px;"></i>
                      </span>
                      <el-form-item label="奖品Icon" required>
                        <upload-image v-model="item.icon" :imgSize="1"
                          :text="['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽度248px,高度236px']"></upload-image>
                      </el-form-item>
                      <el-form-item label="奖品id">
                        <el-input v-model="item.id" size="mini" placeholder="请输入奖品id" :clearable="true"
                          :disabled="true"></el-input>
                      </el-form-item>
                      <el-form-item id="label" size="0" label="奖品可抽取份数(为0表示不限制)"
                        :prop="'gifts.' + index + '.limitCount'" :rules="[
                          { required: true, message: '奖品可抽取份数不能为空', trigger: 'blur' },
                          { type: 'number', message: '奖品可抽取份数必须为数字值' },
                          { pattern: /^[1-9]+[0-9]*$|^0$/, message: '非负整数（正整数 + 0）', trigger: 'blur' }
                        ]">
                        <el-input v-model.number="item.limitCount" size="mini" placeholder="请输入奖品可抽取份数"
                          :clearable="true"></el-input>
                      </el-form-item>
                      <el-form-item label="中奖概率 百分值" :prop="'gifts.' + index + '.probability'" :rules="[
                        { required: true, message: '中奖概率不能为空', trigger: 'blur' },
                        { pattern: /^([0-9]{1,3}(\.\d{1,2})?|100(\.[0]{2})?)$/, message: '非负数（正数 + 0）最多两位小数', trigger: 'blur' }
                      ]">
                        <el-input v-model="item.probability" size="mini" :precision="2" placeholder="请输入中奖概率"
                          :clearable="true"></el-input>
                      </el-form-item>
                      <el-form-item label="类型">
                        <el-radio-group v-model="item.type" @change="function (e) {
                          skuType(e, index)
                        }">
                          <el-radio :label="0">无奖品</el-radio>
                          <el-radio :label="1">实体物品</el-radio>
                          <el-radio :label="2">克拉数(如果选中克拉数,则你输入的数会被除于10000)</el-radio>
                          <el-radio :label="3">优惠券</el-radio>
                          <el-radio :label="4">经验值</el-radio>
                          <el-radio :label="5">抽奖机会</el-radio>
                          <el-radio :label="6">勋章</el-radio>
                          <el-radio :label="7">属性值</el-radio>
                          <el-radio :label="8">机会卷</el-radio>
                          <el-radio :label="9">打卡任务</el-radio>
                          <el-radio :label="10">委托卡片</el-radio>
                          <el-radio :label="11">大赛</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="虚拟物品值" required>
                        <el-input v-model="item.value" size="mini" placeholder="请输入虚拟物品值(id)" :clearable="true"
                          :disabled="item.type == 0 || 1 || 2 || 4 ? true : false"
                          v-if="item.type == 0 || item.type == 1 || item.type == 2 || item.type == 4"></el-input>
                        <el-select v-if="item.type == 3" clearable class="filter-item" v-model="item.value"
                          placeholder="请选择优惠券" style="margin-right: 20px;" filterable reserve-keyword>
                          <el-option v-for="item in couponsList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                        </el-select>
                        <el-select v-if="item.type == 5" clearable class="filter-item" v-model="item.value"
                          placeholder="请选择抽奖" style="margin-right: 20px;" filterable reserve-keyword>
                          <el-option v-for="item in rafflesList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                        </el-select>
                        <el-select v-if="item.type == 6" clearable class="filter-item" v-model="item.value"
                          placeholder="请选择勋章" style="margin-right: 20px;">
                          <el-option v-for="item in medalsList" :key="item.id" :label="item.name"
                            :value="item.id"></el-option>
                        </el-select>
                        <el-select v-model="item.value" placeholder="请选择属性" v-if="item.type == 7">
                          <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                            <el-option v-for="item in group.options" :key="item.value" :label="item.label"
                              :value="item.value"></el-option>
                          </el-option-group>
                        </el-select>
                        <el-select v-if="item.type == 8" clearable class="filter-item" v-model="item.value"
                          placeholder="请选择委托" style="margin-right: 20px;">
                          <el-option v-for="getCR in getCRsList" :key="getCR.id" :label="getCR.name"
                            :value="getCR.id"></el-option>
                        </el-select>
                        <el-select v-if="item.type == 9" clearable filterable class="filter-item" v-model="item.value"
                          placeholder="请选择打卡任务" style="margin-right: 20px;" reserve-keyword>
                          <el-option v-for="getCR in getsThemeList" :key="getCR.id" :label="getCR.title"
                            :value="getCR.id"></el-option>
                        </el-select>
                        <el-select v-if="item.type == 10" clearable class="filter-item" v-model="item.value2"
                          placeholder="请选择委托" style="margin-right: 20px;" @change="function (e) {
                            skusType(e, index)
                          }">
                          <el-option v-for="getCR in getCRsList" :key="getCR.id" :label="getCR.name"
                            :value="getCR.id"></el-option>
                        </el-select>
                        <el-select v-if="item.type == 10" clearable class="filter-item" v-model="item.value"
                          placeholder="请选择委托卡片" style="margin-right: 20px;" :disabled="item.value2 == ''">
                          <el-option v-for="getCR in item.getCardList" :key="getCR.id"
                            :label="getCR.companyName + ' -酬劳:' + getCR.reward" :value="getCR.id"></el-option>
                        </el-select>
                        <el-select v-if="item.type == 11" clearable class="filter-item" v-model="item.value"
                          placeholder="请选择大赛" style="margin-right: 20px;">
                          <el-option v-for="item in megagameList" :key="item.id" :label="item.title"
                            :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-collapse-item>
                  </el-collapse>
                  <div style="display: flex;justify-content: center;margin-top: 14px;">
                    <!-- <el-button type="primary" size="mini" @click="addList">+增加奖品</el-button> -->
                    <el-button type="danger" size="mini" @click="removeList(index)" v-if="index !== 0">-删除奖品</el-button>
                  </div>
                </el-collapse-item>
                <div style="display: flex;justify-content: center;margin-bottom: 14px;margin-top: 14px;">
                  <el-button type="primary" size="mini" @click="addList">+增加奖品</el-button>
                  <!-- <el-button
                type="danger"
                size="mini"
                @click="removeList(index)"
                v-if="index !== 0"
            >-删除奖品</el-button>-->
                </div>
              </el-collapse>
            </div>
          </el-tab-pane>
          <el-tab-pane label="门槛集合" :name="1">

            <div style="border:1px solid #DCDFE6;padding:0 0 20px 0;margin-bottom: 20px;">
              <div v-for="(item, index) in form.thresholds" :key="index" style="margin-top: 20px;">
                <el-form-item label="开始时间" prop="startTime">
                  <el-date-picker :disabled="item.timeLimit == 2 ? false : true" v-model="item.startLimitTime"
                    type="datetime" placeholder="选择开始时间" @change="function (e) {
                      getStartLimitTime(e, index)
                    }" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                  <el-date-picker :disabled="item.timeLimit == 2 ? false : true" v-model="item.endLimitTime"
                    type="datetime" placeholder="选择结束时间" @change="function (e) {
                      getEndLimitTime(e, index)
                    }" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="限定时间">
                  <el-radio-group v-model="item.timeLimit" @change="function (e) {
                    getTimeLimit(e, index)
                  }">
                    <el-radio :label="0">不限定</el-radio>
                    <el-radio :label="1">活动期间</el-radio>
                    <el-radio :label="2">指定时间</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="门槛类型">
                  <el-radio-group v-model="item.type" @change="function (e) {
                    getThreshold(e, index)
                  }">
                    <el-radio :label="1">绑定关系</el-radio>
                    <el-radio :label="2">消费指定商品</el-radio>
                    <el-radio :label="3">消费满N元</el-radio>
                    <el-radio :label="4">消费满N单</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="门槛值">
                  <el-input v-model="item.value" placeholder="请输入门槛值" :clearable="true"></el-input>
                </el-form-item>
                <div style="display: flex;justify-content: center;">
                  <el-button type="primary" size="mini" @click="addThreshold">+增加门槛</el-button>
                  <el-button type="danger" size="mini" @click="removeThreshold(index)"
                    v-if="index !== 0">-删除门槛</el-button>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>

      <el-form-item label="时间类型">
        <el-radio-group v-model="form.timeType">
          <el-radio :label="0">指定时间</el-radio>
          <el-radio :label="1">永久</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="form.timeType == 0" label="开始时间" prop="startTime" :rules="[
        { required: true, message: '请选择日期', trigger: 'change' }
      ]">
        <el-date-picker v-model="form.startTime" type="datetime" placeholder="选择开始时间" @change="dataSearch"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item v-if="form.timeType == 0" label="结束时间" prop="endTime" :rules="[
        { required: true, message: '请选择日期', trigger: 'change' }
      ]">
        <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择结束时间" @change="dataEnd"
          value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="状态 ">
        <el-radio-group v-model="form.status" @change="selectStatus">
          <el-radio :label="0">未开始</el-radio>
          <el-radio :label="1">进行中</el-radio>
          <el-radio :label="2">已关闭</el-radio>
        </el-radio-group>
      </el-form-item>-->
      <el-form-item label="活动规则" prop="ruleInfoType">
        <el-radio-group v-model="form.ruleInfoType" @change="selectRuleInfoType">
          <el-radio :label="1">文字</el-radio>
          <el-radio :label="2">图片</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label required v-if="form.ruleInfoType == 2">
        <upload-image v-model="form.ruleInfoContent" :max="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽度750px,高度随着宽度']"></upload-image>
      </el-form-item>

      <el-form-item label required v-if="form.ruleInfoType == 1" prop="ruleInfoContent">
        <div class="ql-editor">
          <quill-editor ref="myQuillEditor" v-model="form.ruleInfoContent" :options="editorOption"
            @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" />
        </div>
      </el-form-item>
      <el-form-item label="背景颜色" required prop="backColor">
        <el-color-picker v-model="form.backColor" size="mini"></el-color-picker>
      </el-form-item>
      <el-form-item label="背景图片" required prop="backImg">
        <upload-image v-model="form.backImg" :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽度750px,高度随着宽度']"></upload-image>
      </el-form-item>
      <el-form-item label="介绍视频" required prop="video">
        <upload-video v-model="form.video" :max="1"></upload-video>
      </el-form-item>
      <el-form-item label="抽奖禁用图标" required prop="drawDisIcon">
        <upload-image v-model="form.drawDisIcon" :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽高度225px']"></upload-image>
      </el-form-item>
      <el-form-item label="抽奖图标" required prop="drawIcon">
        <upload-image v-model="form.drawIcon" :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif', '图片宽高度225px']"></upload-image>
      </el-form-item>
      <div class="tc" v-if="!editorialJudgment">
        <el-button type="primary" size="default" @click="save('form')">确定</el-button>
        <el-button size="default" @click="closeFn">取消</el-button>
      </div>
      <div class="tc" v-if="editorialJudgment">
        <el-button @click="closeFn">取 消</el-button>
        <el-button type="primary" @click="getModify('form')">确 定</el-button>
      </div>
    </el-form>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import uploadImage from '@/components/uploadImage/index.vue'
import uploadVideo from '@/components/uploadVideo/index.vue'

import { getToken } from '@/api/demo/classification/index'
import { attList } from '@/api/demo/attributes/index'
import {
  getLuckDraw,
  getLuckInfo,
  getLuckUpdate
  , getLuckList } from '@/api/demo/luckDraw/index'
import { getArrList } from '@/api/demo/discount/index'
import { getMedalList } from '@/api/demo/medal/index'
import { getCRList, getCard } from '@/api/demo/CommissionRelate/index'
import { getThemeList } from '@/api/demo/punchInActivity/index'
/**
 * 富文本工具
 */
import { quillEditor, Quill } from 'vue-quill-editor'
import { replayContent, initEditor, option, initTitle } from '@/utils/editor'

import { megagameList } from '@/api/demo/competition/index'
import { max } from 'moment/moment'
initEditor(Quill)

export default {
  name: 'addAndModifyADdd',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    uploadImage,
    quillEditor,
    uploadVideo
  },
  watch: {
    // $route(to, from) {
    //   this.getList();
    // }
  },
  data () {
    return {
      optionValue: 0,
      couponsList: [], // 优惠券列表
      rafflesList: [], // 抽奖列表
      medalsList: [], // 勋章列表
      getCRsList: [], // 委托管理
      getsThemeList: [], // 打卡任务
      megagameList: [], // 大赛
      tableKey: 0,
      options: [
        { label: '亲密关系', options: [] },
        { label: '气质特征', options: [] },
        { label: '能力属性', options: [] }
      ],
      form: {
        name: null, // 活动名称
        timeType: 0,
        cipherId: null, // 口令id
        cipherStatus: 0, // 开启口令增加抽奖次数 0 关闭 1 开启
        countLimit: 0, // 总限制次数
        dayCountLimit: 0, // 每日限制抽奖次数
        defaultCount: 0, // 默认抽奖次数
        startTime: null, // 开始时间
        endTime: null, // 结束时间
        ruleInfoType: 2, // 1 文字 2 图片
        ruleInfoContent: null, // 规则内容
        userLimit: 0, // 限制参与人数
        // status: 0, //0 未开始 1 进行中 2 已关闭
        optionId: 0, // 选项
        gifts: [
          {
            count: 0, // 数量
            icon: null, // 奖品图标
            icons: [], // 奖品图标
            id: null, // 奖品id
            limitCount: 0, // 奖品可抽取份数
            name: null, // 奖品名称
            probability: 0, // 中奖概率 百分值
            type: 0, // 0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会 6 勋章
            value: '', // 虚拟物品值
            value2: '',
            getCardList: [] // 卡片集合
          }
        ], // 奖品集合
        thresholds: [
          {
            endLimitTime: null, // 限定时间: 结束时间
            startLimitTime: null, // 限定时间: 开始时间
            timeLimit: 0, // 限定时间: 0 不限定 1. 活动期间 2.指定时间
            type: 3, // 门槛类型: 1.绑定关系 2.消费指定商品 3.消费满N元 4.消费满N单
            value: 0 // 门槛值
          }
        ], // 门槛集合
        backColor: null, // 背景颜色
        backImg: '', // 背景图片
        drawDisIcon: '', // 抽奖禁用图标
        drawIcon: '' // 抽奖图标
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入活动名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 30,
            message: '长度在 1 到 30 个字符',
            trigger: 'blur'
          }
        ],
        countLimit: [
          { required: true, message: '总限制次数不能为空' },
          { type: 'number', message: '总限制次数必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        dayCountLimit: [
          { required: true, message: '每日限制抽奖次数不能为空' },
          { type: 'number', message: '每日限制抽奖次数必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        defaultCount: [
          { required: true, message: '默认抽奖次数不能为空' },
          { type: 'number', message: '默认抽奖次数必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ],
        userLimit: [
          { required: true, message: '限制参与人数不能为空' },
          { type: 'number', message: '限制参与人数必须为数字值' },
          {
            pattern: /^[1-9]+[0-9]*$|^0$/,
            message: '非负整数（正整数 + 0）',
            trigger: 'blur'
          }
        ]
      },
      // 富文本框参数设置
      editorOption: option,
      uploadData: { key: '', token: '' },
      rewardId: null,
      editorialJudgment: false,
      true: null
    }
  },
  created () {
    let that = this
    that.rewardId = that.$route.query.id
    that.true = that.$route.query.true
    // console.log("dddd", that.rewardId);
    if (that.rewardId != undefined) {
      if (that.true == 'true') {
        that.editorialJudgment = false
        getLuckInfo(that.rewardId).then(res => {
          console.log('res', res)
          res.optionId = 0
          res.gifts.forEach(tem => {
            tem.icons = []
          })
          for (let index = 0; index < res.gifts.length; index++) {
            res.gifts[index].icons = res.gifts[index].icon.split()
            res.gifts[index].id = null
          }
          if (res.ruleInfoContent != '' && res.ruleInfoType == 2) {

          }
          console.log('res.backImg ', res.backImg)
          that.form = res
          console.log('that', that.form)
        })
        console.log('that.editorialJudgment', that.form)
      } else {
        getLuckInfo(that.rewardId).then(res => {
          that.form = res
        })
        that.editorialJudgment = true
      }
    } else if (that.rewardId == undefined) {
      that.editorialJudgment = false
    }
    that.couponList()
    that.raffleList()
    that.medalList()
    that.getAttributes()
    that.getCRList()
    that.getThemesList()
    that.getMegagameList()
  },
  mounted () {
    let that = this
    getToken({}).then(res => {
      that.uploadData.token = res.token
      that.https = res.domain
    })
  },
  methods: {
    // 大赛
    getMegagameList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 40,
        keyword: '',
        classifyId: ''
      }
      megagameList(listQuery).then(res => {
        that.megagameList = res.records
      })
    },
    // 优惠券
    couponList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 2000,
        keyword: '',
        stat: 1,
        type: ''
      }
      getArrList(listQuery).then(res => {
        that.couponsList = res.records
      })
    },
    // 抽奖列表
    raffleList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        name: null, // 名称
        pageSize: 200, // 每页显示的大小
        status: 1 // 状态
      }
      getLuckList(listQuery).then(res => {
        that.rafflesList = res.records
      })
    },
    // 勋章列表
    medalList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200 // 每页显示的大小
      }
      getMedalList(listQuery).then(res => {
        that.medalsList = res.records
      })
    },
    // 获取属性相关
    getAttributes () {
      let listQuery = {
        currentPage: 1,
        pageSize: 40
      }
      attList(listQuery, 1).then(res => {
        res.records.forEach(item => {
          this.options[0].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 2).then(res => {
        res.records.forEach(item => {
          this.options[1].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
      attList(listQuery, 4).then(res => {
        res.records.forEach(item => {
          this.options[2].options.push({
            value: item.id,
            label: item.name
          })
        })
      })
    },
    getCRList () {
      let that = this
      let listQuery = {
        currentPage: 1, // 当前页数
        pageSize: 200, // 每页显示的大小
        status: 1
      }
      getCRList(listQuery).then(res => {
        that.getCRsList = res.records
      })
    },
    // 获取打卡任务
    getThemesList () {
      let that = this
      let listQuery = {
        currentPage: 1,
        pageSize: 2000,
        classifyId: null,
        keyword: null,
        status: 1
      }
      getThemeList(listQuery).then(res => {
        that.getsThemeList = res.records
      })
    },
    // 卡片列表
    getCardsList (e, index) {
      let that = this
      getCard(e).then(res => {
        that.form.gifts[index].getCardList = res
      })
    },
    skusType (e, index) {
      console.log('ee', e, index)
      let that = this
      if (e == '') {
      } else {
        that.getCardsList(e, index)
      }
    },
    /// /开启口令增加抽奖次数 0 关闭 1 开启
    selectCipherStatus (e) {
      this.form.cipherStatus = e
    },
    // 活动规则
    selectRuleInfoType (e) {
      let that = this
      that.form.ruleInfoType = e
      initTitle()
    },
    // 选项
    selectOption (e) {
      this.form.optionId = e
    },
    // 类型
    skuType (e, index) {
      // console.log("index", e,index);
      let that = this
      for (let index2 = 0; index2 < that.form.gifts.length; index2++) {
        if (index2 == index) {
          that.form.gifts[index2].type = e
        }
      }
      // console.log("index", this.form.gifts);
    },
    // 门槛类型
    getThreshold (e, index) {
      // console.log("index", e,index);
      let that = this
      for (let index2 = 0; index2 < that.form.thresholds.length; index2++) {
        if (that.form.thresholds[index2] == index) {
          that.form.thresholds[index2].type = e
        }
      }
      // console.log("index", this.form.thresholds);
    },
    // 限定时间
    getTimeLimit (e, index) {
      let that = this
      for (let index2 = 0; index2 < that.form.thresholds.length; index2++) {
        if (that.form.thresholds[index2] == index) {
          that.form.thresholds[index2].timeLimit = e
        }
        if (e == 0 || e == 1) {
          that.form.thresholds[index2].endLimitTime = null
          that.form.thresholds[index2].startLimitTime = null
        }
      }
      // console.log("index", this.form.thresholds, e);
    },
    // 开始时间
    dataSearch (e) {
      this.form.startTime = e
      // console.log("e", this.form.startTime);
    },
    // 结束时间
    dataEnd (e) {
      this.form.endTime = e
      // console.log("e", this.form.endTime);
    },
    // 门槛集合开始时间
    getStartLimitTime (e, index) {
      let that = this
      for (let index2 = 0; index2 < that.form.thresholds.length; index2++) {
        if (that.form.thresholds[index2] == index) {
          that.form.thresholds[index2].startLimitTime = e
        }
      }
      // console.log("index1", this.form.thresholds);
    },
    // 门槛集合结束时间
    getEndLimitTime (e, index) {
      let that = this
      for (let index2 = 0; index2 < that.form.thresholds.length; index2++) {
        if (that.form.thresholds[index2] == index) {
          that.form.thresholds[index2].endLimitTime = e
        }
      }
      // console.log("index2", this.form.thresholds);
    },
    // 状态
    selectStatus (e) {
      this.form.status = e
    },
    // 新增奖品集合
    addList () {
      this.form.gifts.push({
        count: 0, // 数量
        icon: null, // 奖品图标
        icons: [],
        id: null, // 奖品id
        name: null, // 奖品名称
        probability: 0, // 中奖概率 百分值
        type: 0, // 0 无奖品 1 实体物品 2 克拉数 3 优惠券 4 经验值 5 抽奖机会
        value: 0, // 虚拟物品值
        value2: '',
        getCardList: [], // 卡片集合
        limitCount: 0 // 奖品可抽取份数
      })
    },
    // 删除奖品集合
    removeList (index) {
      this.form.gifts.splice(index, 1)
      this.form.gifts.forEach((item, index) => {
        item.index = index
      })
    },
    // 新增门槛
    addThreshold () {
      this.form.thresholds.push({
        endLimitTime: null, // 限定时间: 结束时间
        startLimitTime: null, // 限定时间: 开始时间
        timeLimit: 0, // 限定时间: 0 不限定 1. 活动期间 2.指定时间
        type: 1, // 门槛类型: 1.绑定关系 2.消费指定商品 3.消费满N元 4.消费满N单
        value: 0 // 门槛值
      })
    },
    // 删除门槛
    removeThreshold (index) {
      this.form.thresholds.splice(index, 1)
      this.form.thresholds.forEach((item, index) => {
        item.index = index
      })
    },
    onEditorBlur (quill) {
      console.log('editor blur!', this.form.content, quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', this.form.content, quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)
    },
    // 新增
    save (form) {
      let that = this
      console.log('save : form', that.form)
      if (that.form.startTime == null || that.form.endTime == null) {
        that.$notify({
          title: '警告',
          message: '开始时间和结束不能为空',
          type: 'error',
          duration: 2000
        })
        return false
      }

      if (that.form.ruleInfoContent == null) {
        that.$notify({
          title: '警告',
          message: '活动规则不能为空',
          type: 'error',
          duration: 2000
        })
        return false
      }
      that.form.ruleInfoContent = replayContent(that.form.ruleInfoContent)
      if (
        that.form.backColor == '' ||
        that.form.backImg == '' ||
        that.form.drawDisIcon == '' ||
        that.form.drawIcon == ''
      ) {
        that.$notify({
          title: '成功',
          message: '背景颜色/背景图片/抽奖禁用图标/抽奖图标 不能为空',
          type: 'error',
          duration: 2000
        })
      }
      that.$refs[form].validate(valid => {
        if (valid) {
          getLuckDraw(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push({
              path: '/demo/luckDraw'
            })
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 新增返回
    closeFn () {
      let that = this
      that.$router.push({
        path: '/demo/luckDraw'
      })
    },
    // 详情
    getInfo () {
      let that = this
      getLuckInfo(that.rewardId).then(res => {
        console.log('res3', res)
        var key = 'optionId'
        var value = 0
        let keys = 'ruleInfoContent2'
        var value2 = []
        res[key] = value
        res[keys] = value2
        res.gifts.forEach(tem => {
          tem.icons = []
        })
        for (let index = 0; index < res.gifts.length; index++) {
          res.gifts[index].icons = res.gifts[index].icon.split()
        }

        that.form = res
        console.log('that', that.form)
      })
    },
    getModify (form) {
      let that = this
      console.log('that.form', that.form)
      if (that.form.startTime == null || that.form.endTime == null) {
        that.$notify({
          title: '警告',
          message: '开始时间和结束不能为空',
          type: 'error',
          duration: 2000
        })
        return false
      }

      if (that.form.ruleInfoContent == null) {
        that.$notify({
          title: '警告',
          message: '活动规则不能为空',
          type: 'error',
          duration: 2000
        })
        return false
      }
      that.form.ruleInfoContent = replayContent(that.form.ruleInfoContent)
      if (
        that.form.backColor == '' ||
        that.form.backImg == '' ||
        that.form.drawDisIcon == '' ||
        that.form.drawIcon == ''
      ) {
        that.$notify({
          title: '成功',
          message: '背景颜色/背景图片/抽奖禁用图标/抽奖图标 不能为空',
          type: 'error',
          duration: 2000
        })
      }
      that.$refs[form].validate(valid => {
        if (valid) {
          getLuckUpdate(that.form, that.rewardId).then(res => {
            that.$notify({
              title: '成功',
              message: '编辑成功',
              type: 'success',
              duration: 2000
            })
            that.$router.push({
              path: '/demo/luckDraw'
            })
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.ql-editor {
  padding: 0;
}

.tc {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-content: center;
}

/deep/#label .el-form-item__label {
  line-height: 20px;
}
</style>
